import { createSelector } from 'reselect';

const selectLoader = state => state.get('loaderReducer');

const makeLoaderState = () => createSelector(selectLoader, loader => (loader ? loader.get('isConnecting') : null));

export default makeLoaderState;
